var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.36,14.95l1.34-1.34,.29-.71V7.1l-.29-.71L13.61,2.29l-.71-.29H7.1l-.71,.29L2.29,6.39l-.29,.71v5.8l.29,.71,4.1,4.1,.71,.29h5.8l.71-.29,1.34-1.34,5.34,5.34,1.41-1.41-5.34-5.34Zm-.36-2.46l-3.51,3.51H7.51l-3.51-3.51V7.51l3.51-3.51h4.97l3.51,3.51v4.97Zm-9-3.49h6v2H7v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchMinus);
export default __webpack_public_path__ + "static/1768397567/media/icon-search-minus.d8cb88d06fdfd07c39fea9960a0afc59.svg";
export { ForwardRef as ReactComponent };